var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"prefectSelect",staticClass:"prefect-select-wrapper"},[_c('router-view',{staticClass:"main-wrapper"}),(_vm.footShow)?_c('p',{staticClass:"tips-invest"},[_vm._v("市场有风险、出借需谨慎")]):_vm._e(),(_vm.footShow)?_c('Mfooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }